import i18n from 'i18next';

export const longEnough = (val) => (val && val.length < 6) ? "Should be more than 6 characters" : undefined;
export const cardExpiry = (val) => {
    //const { t } = useTranslation();
    //console.log(val && val.trim().length === 5);
    
    const isValidLength = (val && val.trim().length === 5);
    if (isValidLength === false)
        return i18n.t("Invalid Expiry Date Format MM/YY");

    const month = parseInt(val.substring(0, 2)),
        year = parseInt(val.substring(2, 4));
    if (month > 12)
        return i18n.t("Month should be between 01 - 12");
    const currentYear = parseInt(new Date().getFullYear().toString().substr(-2));
    if (year < currentYear)
        return `${i18n.t("Year must be greater than")} ${currentYear}`;

    return undefined;


}
export const passwordsMatch= (vals) => vals.password === vals.confirmPassword;
export const required = value => value ? undefined : 'Required*';
export const minValue = min => value =>
    value && value < min ? `Must be at least ${min}` : undefined;
export const maxLength = max => value =>
    value && value.length > max ? `Must be ${max} characters or less` : undefined;
export const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;
export const isVlidEmail = value =>
    !value || !/^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]+[\W]*;{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]+)[\W]*$/i.test(value) ? false : true;
export const alphaNumeric = value =>
    value && /[^a-zA-Z0-9 ]/i.test(value)
        ? 'Only alphanumeric characters'
        : undefined;
export const phoneNumber = value =>
    value && !/^(0|[1-9][0-9]{9})$/i.test(value)
        ? 'Invalid phone number, must be 10 digits'
        : undefined;
export const isRequired = value => value && value.length > 0 ? false : true;
